
import { Vue } from 'vue-class-component';

export default class SidebarNavigation extends Vue {}
